import { render, staticRenderFns } from "./NewCategoryItem.vue?vue&type=template&id=120b970c&scoped=true&"
import script from "./NewCategoryItem.vue?vue&type=script&lang=js&"
export * from "./NewCategoryItem.vue?vue&type=script&lang=js&"
import style0 from "./NewCategoryItem.vue?vue&type=style&index=0&id=120b970c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120b970c",
  null
  
)

export default component.exports